import { tokenKey } from '@ninja/consts';
import storage from '@ninja/storage';
import { createSlice } from '@reduxjs/toolkit';
import ninjaApi from 'store/redux/apis';

const initialState = {
  auth: false,
  loading: Boolean(storage.get(tokenKey)),
  user: {},
  token: null,
};

export const state = createSlice({
  name: 'user',
  initialState: initialState,
  reducers: {
    /**
     * Logout user and set everything to initial
     */
    logoutAction: (state) => {
      state.auth = false;
      state.loading = false;
      state.user = {};
    },
  },
  extraReducers: (builder) => {
    // When user is bootstraped and not error returned
    builder.addMatcher(ninjaApi.endpoints.bootstrapUser.matchFulfilled, (state, { payload }) => {
      console.log('bootstrapUser matchFulfilled, user logged in');
      state.user = payload.user;
      state.auth = true;
      state.loading = false;
      state.token = payload.token;
    });
  },
});

export const { logoutAction } = state.actions;

export default state.reducer;
